import React from 'react';
import styles from './styles.scss';
import classnames from 'classnames';
const { Fragment, useState } = React;
import Popup from '../Popup';

import { Icons } from '@densityco/ui';

type ChoiceHref = {
  id: any;
  label: React.ReactNode;
  href: string;
};

type ChoiceOnClick = {
  id: any;
  label: React.ReactNode;
  onClick: (e: React.MouseEvent<HTMLLIElement, MouseEvent>) => void;
};

const MoreButton: React.FunctionComponent<{
  tabFocusable?: boolean;
  choices: Array<ChoiceHref | ChoiceOnClick>;
}> = ({ tabFocusable = true, choices }) => {
  const [open, setOpen] = useState(false);
  return (
    <Popup
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      position={{ top: 44, right: 0 }}
      target={
        <div className={classnames(styles.moreButton, { [styles.open]: open })} data-test-id="more-button">
          <Icons.More color="currentColor" />
        </div>
      }
      tabFocusable={tabFocusable}
    >
      <ul className={styles.itemList}>
        {choices.map((choice, index) => {
          const item = (
            <li onClick={(choice as any).onClick} tabIndex={tabFocusable ? 0 : -1} data-test-id={`more-button-choice-${choice.id}`}>
              <span className={styles.label}>{choice.label}</span>
            </li>
          );

          if ((choice as any).href) {
            const c = choice as ChoiceHref;
            return (
              <a
                key={c.id}
                href={c.href}
                onClick={() => setOpen(false)}
                tabIndex={tabFocusable  ? 0 : -1}
              >
                {item}
              </a>
            );
          } else {
            return <Fragment key={choice.id}>{item}</Fragment>;
          }
        })}
      </ul>
    </Popup>
  );
};

export default MoreButton;
